import { darkenHex, hexToRgb } from "@/lib/color";

export function makeClusterDiv(count) {
  const div = document.createElement("div");
  div.className = "cluster-bubble";
  div.textContent = String(count);

  let size = 34;
  if (count >= 10) size = 38;
  if (count >= 50) size = 44;
  if (count >= 200) size = 52;

  div.style.width = `${size}px`;
  div.style.height = `${size}px`;
  div.style.fontSize = `${Math.max(12, Math.round(size * 0.32))}px`;

  const baseBlue = "#4688ee";
  const bg =
    count >= 200 ? "#e74e40" :
    count >= 50  ? "#f6c015" :
    count >= 10  ? "#3cad5c" :
                  darkenHex(baseBlue, 20);

  const { r, g, b } = hexToRgb(bg);

  div.style.background = bg;
  div.style.border = "3px solid #ffffff";
  div.style.borderRadius = "9999px";
  div.style.display = "flex";
  div.style.alignItems = "center";
  div.style.justifyContent = "center";
  div.style.fontWeight = "800";
  div.style.color = "#ffffff";
  div.style.position = "relative";
  div.style.cursor = "pointer";
  div.style.filter = count < 10 ? "saturate(80%)" : "none";

  div.style.boxShadow = `
    0 0 0 5px rgba(${r}, ${g}, ${b}, 0.22),
    0 0 0 11px rgba(${r}, ${g}, ${b}, 0.12),
    0 4px 10px rgba(0,0,0,0.15)
  `;

  div.style.transition = "transform 0.15s ease";
  div.onmouseenter = () => (div.style.transform = "scale(1.08)");
  div.onmouseleave = () => (div.style.transform = "scale(1)");

  return div;
}